import styled from '@mui/material/styles/styled'
import Tabs from '@mui/material/Tabs'

export const TabsStyled = styled(Tabs, { name: 'TabsStyled' })`
  border-bottom: 1px solid #e8e8e8;
`
